module.exports = __webpack_public_path__ + "static/media/melding.a2d008db51d4a956ff3b7408d525b855.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/features/melding.png
// module id = 2710
// module chunks = 1